import React, {Fragment} from "react";
import Currency from "./Currency";

const ConfiguratorSurveyRenderResult = ({ result, currency }) => {
  if (result === null)
    return '-';
  if (result === undefined)
    return null;

  const items = Array.isArray(result) ? result : [result];
  const content = items.map((item, index) => {
    if (item === null || item === undefined)
      return null;
    return <Fragment key={index}>
      {
        currency
        ? <Currency value={result} />
        : <h2>{item}</h2>
      }
    </Fragment>;
  });

  return <div className="flex flex-col gap-2">{content}</div>;
};

export default ConfiguratorSurveyRenderResult;
